import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HandleConnectivityComponent } from './core/handle-connectivity/handle-connectivity.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HandleConnectivityComponent],
  template: `
    <router-outlet />
    <handle-connectivity>
      <div
        class="z-50 bg-red-500 h-16 text-white flex items-center justify-center fixed w-full bottom-0 left-0"
        offline
      >
        No Internet Connection...
      </div>
    </handle-connectivity>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
